<template>
    <div>
        <h3 class="display-4 text-center">Nächste Aufgaben</h3>
        <ul class="task-list" :key="tick">
            <li v-for="atask in taskPreview" :key="atask.id" class="btn btn-block btn-default btn-lg btn-icon" @click="showModal(atask)">
                <circular-count-down-timer
                        v-if="$options.filters.differenceFromNowInSeconds(atask.doAt) > 0 && $options.filters.differenceFromNowInSeconds(atask.doAt) < 300"
                        class="btn-inner--icon counter float-sm-right"
                        :initial-value="$options.filters.differenceFromNowInSeconds(atask.doAt)"
                        :size="50"
                        :show-hour="false"
                        :show-second="true"
                        :show-minute="true"
                        :hour-label="''"
                        :minute-label="''"
                        :second-label="''"
                        @finish="showByCountdown(atask)"
                ></circular-count-down-timer>
                <badge class="float-sm-right" type="danger" v-else-if="$options.filters.differenceFromNowInSeconds(atask.doAt) < 0"  v-b-tooltip.hover :title="$options.filters.formatDate(atask.doAt)">überfällig</badge>
                <span class="text-muted float-sm-right small" v-else v-b-tooltip.hover :title="$options.filters.formatDate(atask.doAt)">{{atask.doAt|formatDateFromNow}}</span>
                <span class="btn-inner--text floating">{{atask.type}}</span>
            </li>
        </ul>
        <modal :show.sync="show"
               gradient="info"
               modal-classes="modal-info modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification">Aufgabe: {{task.type}}</h6>
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4">Anweisung:</h4>
                <p>{{task.description}}</p>

<!---
                <select v-model="task.answer" class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="answer in task.possibleAnswers" :key="answer.value" :value="answer.value">{{ answer.value }}</option>
                </select> --->

                <b-form-group
                        label="Antwortmöglichkeiten"
                        v-slot="{ ariaDescribedby }"
                >
                    <b-form-radio-group
                            id="btn-radios-2"
                            style="width:100%;"
                            v-model="task.answer"
                            :options="task.possibleAnswers"
                            :aria-describedby="ariaDescribedby"
                            text-field="value"
                            button-variant="outline-secondary"
                            size="lg"
                            name="radio-btn-outline"
                            buttons
                    ></b-form-radio-group>
                </b-form-group>



                <textarea v-model="task.comment" class="form-control form-control-alternative" rows="3" placeholder="Hier ist Platz für Ihre Anmerkung"></textarea>

                <div v-if="getProfile !== null">
                    <p class="lead">Sie signieren diese Aufgabe als:<br><b>{{ getProfile.name }}</b></p>
                    <p>Wenn Sie nicht {{ getProfile.name  }} sind, können Sie Ihr Profil <a href="#" @click.prevent="$store.dispatch('profiles/setNoActiveProfile')"><badge type="default">hier</badge></a> ändern.</p></div>

            </div>
            <template slot="footer">
                <button class="btn btn-icon my-4 btn-secondary" :disabled="isLoading" @click="doTaskAndClose">
                    <span :key="tick+'bcn1'" class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-check-bold"></i></span>
                    <span class="btn-inner--text">erledigen</span></button>


                <p v-if="task.isAutocomplete" align="right" class="text-sm ">Sekunden bis Kontrollgang automatisch erledigt wird:</p>
                <circular-count-down-timer :key="componentKey2" v-if="show && task.isAutocomplete" :initial-value="300"
                                           :size="70"
                                           :show-minute="false"
                                           :show-hour="false"
                                           seconds-stroke-color="#2dce89"
                                           second-label=""
                                           style="text-align: center"
                                           ref="countdown2"
                                           @finish="doTaskAndClose"
                ></circular-count-down-timer>
                <!---<base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="show = false">
                    Close
                </base-button>--->
            </template>
        </modal>
    </div>
</template>

<script>
    import Push from 'push.js';


    export default {
        name:"Tasks",
        data() {
            return{
                tick: 1,
                isLoadingTasks: false,
                isLoading: false,
                refreshTimer: null,
                show: false,
                componentKey2: 1,
                task: {
                    id: null,
                    taskTemplate: null,
                    description: '',
                    possibleAnswers: [{value:'',action:null}],
                    answer: '',
                    createdAt: null,
                    doneAt: null,
                    doAt: new Date(),
                    isPublic: false,
                    type: '',
                    location: null,
                    user: null,
                    profile: null,
                    isAutocomplete: true,
                    comment: ''
                },
                tasks: [{
                    id: null,
                    taskTemplate: null,
                    description: '',
                    possibleAnswers: [{value:'',action:null}],
                    answer: '',
                    createdAt: null,
                    doneAt: null,
                    doAt: new Date(),
                    isPublic: false,
                    type: '',
                    location: null,
                    user: null,
                    profile: null,
                    isAutocomplete: true,
                    comment: ''
                }]
            }
        },
        created() {
            this.refreshData();
            this.refreshTimer = setInterval(() =>{
                this.refreshData()
            }, 120000);

        },
        computed:{
            taskPreview(){
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return this.tasks.filter(item => typeof item.doneAt === "undefined" || item.doneAt === null ).splice(0,3);
            },
            getProfile(){
                return this.$store.getters['profiles/showActiveProfile']
            }
        },
        methods: {
            refreshData() {
                this.isLoadingTasks = true;
                this.tick++
                this.getData(this.location).then(response => {
                    this.tasks = response.member;
                    this.isLoadingTasks = false;
                    this.tick++
                }).catch(error => {
                  // eslint-disable-next-line no-console
                  console.error(error)
                    // this.$store.dispatch('alert/error',error);
                    this.isLoadingTasks = false;
                    this.tick++
                })
            },
            getData() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/tasks?page=1&order%5BdoAt%5D=asc&exists%5BdoneAt%5D=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });

                            },
                            error => {
                                reject(error);
                            });
                });
            },
            showModal(obj) {
                this.task = JSON.parse(JSON.stringify(obj));
                this.show = true;
            },
            showByCountdown(obj) {
                this.showNotification('/sounds/normal.mp3',obj);
                this.showModal(obj);
            },
            playSound (sound) {
                if(sound) {
                    var audio = new Audio(sound);
                    audio.play();
                }
            },
            showNotification(sound,task) {
                this.playSound(sound);
                this.pushNotiMsg(task.description);
                Push.create("Aufgabe: " + task.type, {
                    body: task.description,
                    icon: '/img/icons/apple-icon.png',
                    timeout: 2400000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                });
            },
            doTask() {
                return new Promise((resolve, reject) => {
                        const header = this.authHeader();
                        header['Content-Type'] = 'application/merge-patch+json';
                        this.task.profile = this.$store.getters['profiles/showActiveProfile']['@id'];
                        let senddata = JSON.parse(JSON.stringify(this.task));
                        senddata.location = this.task.location['@id'];
                        senddata.user = this.task.user['@id'];
                        senddata.taskTemplate = (typeof this.task.taskTemplate['@id'] !== 'undefined') ? this.task.taskTemplate['@id'] : this.task.taskTemplate;
                        const requestOptions = {
                            method: 'PATCH',
                            headers: header,
                            body: JSON.stringify(senddata)
                        };
                        fetch(process.env.VUE_APP_API_SERVER + `/api/tasks/`+senddata.id, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    resolve(response);
                                },
                                error => {
                                    reject(error);
                                });
                });
            },
            doTaskAndClose() {
                if (this.$store.getters['profiles/showActiveProfile'] !== null ) {
                    this.isLoading =true;
                    this.tick++;
                    this.doTask().then(() => {
                        this.$store.dispatch('alert/success','Aufgabe erfolgreich erledigt.')
                        this.refreshData();
                        this.isLoading =false;
                        this.show = false;
                        this.tick++;
                    }).catch(error => {
                        this.$store.dispatch('alert/error',error)
                        this.isLoading =false;
                        this.tick++;
                    })

                } else {
                    this.$store.dispatch('alert/error','Kein Profil ausgewählt!');
                    this.showNotification('/sounds/loud.mp3',this.task);
                    //this.$refs.countdown2.updateTime('30');
                }
            }
        }
    }
</script>

<style scoped>

    .counter {
        width: 90px !important;
    }


    ul.task-list {
        list-style-type: none; /* Remove bullets */
        padding: 0; /* Remove padding */
        margin-left: 0; /* Remove margins */
        margin-bottom: 1rem;
    }

</style>